import React from 'react';
import PropTypes from 'prop-types';

import { defineMessages, injectIntl } from 'react-intl';

import Segment from '../../components/Segment';
import peopleOnCloudImage from './people-on-cloud.png';
import './styles.css';

const messages = defineMessages({
  emptyWelcomeHeader: {
    id: 'repvisits.contacts.empty.welcomeHeader',
    defaultMessage: 'Welcome to Contacts',
  },
  emptyWelcomeMessage: {
    id: 'repvisits.contacts.empty.welcomeMessage',
    defaultMessage: 'Relevant contacts will be dynamically added to this list as you plan Visits and College Fairs. Happy scheduling!',
  },
  emptyWelcomeImageAlt: {
    id: 'repvisits.contacts.empty.imageAlt',
    defaultMessage: 'people in cloud',
  },
});

const ContactsListEmpty = ({ intl }) => (
  <Segment>
    <div styleName="empty-welcome">
      <img
        styleName="empty-welcome-image"
        alt={intl.formatMessage(messages.emptyWelcomeImageAlt)}
        src={peopleOnCloudImage}
      />
      <p styleName="empty-welcome-header">{intl.formatMessage(messages.emptyWelcomeHeader)}</p>
      <p styleName="empty-welcome-message">{intl.formatMessage(messages.emptyWelcomeMessage)}</p>
    </div>
  </Segment>
);

ContactsListEmpty.propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
};

export default injectIntl(ContactsListEmpty);
